app.controller("ExamsManagerEditSelectedItemsController",[
    "$scope", "$uibModalInstance", "$interpolate", "$q", "StaticData", "toastr", "Students", "params", "ConfirmModal", "ExamsManagerService",
    function($scope, $uibModalInstance, $interpolate, $q, StaticData, toastr, Students, params, ConfirmModal, ExamsManagerService) {
        $scope.selectedStudents = params.selectedStudents;
        $scope.selectedSessionId = null;
        $scope.checking = false;

        function filterSessionsWithAvailableSeats(sessions){
            return sessions.filter(function (session) {
                if (session.examHall.withComputers) {
                    return session.freeSeats >= $scope.selectedStudents.length;
                }
                return session.seats.length >= $scope.selectedStudents.length;
            });
        }

        $scope.getSessionsWithFreeSeats = function () {
            return ExamsManagerService.getSessionsWithFreeSeats().then(function (data) {
                $scope.sessions = filterSessionsWithAvailableSeats(data);
            });
        };
        $scope.getSessionsWithFreeSeats();

        $scope.update = async function () {
            $scope.checking = true;
            let selectedSession = $scope.sessions.find(function (session) {
                return session._id === $scope.selectedSessionId;
            });

            let promises = [];

            for(let i = 0; i < $scope.selectedStudents.length; i += 1) {
                promises.push(ExamsManagerService.editExamItem({
                    examItemId: $scope.selectedStudents[i]._id,
                    sessionId: $scope.selectedSessionId,
                    seat: selectedSession.examHall.withComputers ? 0 : selectedSession.seats[i]
                }));
            }
            $q.all(promises).then(function() {
                $scope.checking = false;
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

 }
]);
